import React, { useContext, useState } from 'react';
import { DropDown, Input, InputFile, ModalMsgCtrl } from '../components'
import { DataContext } from '../data/DataContext';
import { catSiNo } from '../data/MochaData'
import { endPoints } from '../../../utils/constanst';
import http from '../../../services/http';
import { useModal } from '../hook';
const Step3 = () => {

    const { AutoEmisionCR, setAutoEmisionCR, ChangeHandler } = useContext(DataContext);
    const changeFiles = (propierties: string, files: Array<File>, isMod: boolean) => setAutoEmisionCR({ ...AutoEmisionCR, [propierties]: files, [`${propierties}IsModified`]: isMod });
    const onChange = (property: string, value: string) => setAutoEmisionCR({ ...AutoEmisionCR, [property]: value });
    const [loadingData, setLoadingData] = useState(false);
    const modalLoading = useModal({ isloading: true } as IModalProps);

    const GetDataByPlate = () => {
        modalLoading.show(`Cargando datos de placa ${AutoEmisionCR.vehiclePlate}...`)
        setLoadingData(true);
        http(endPoints.bienesMuebles('1', AutoEmisionCR.vehiclePlate)).get()
            .then((x) => {
                setAutoEmisionCR({
                    ...AutoEmisionCR,
                    vehicleChasis: x.chasis,
                    vehicleEngine: x.motor,
                    vehicleClass: x.codClaseVehiculoBS,
                    vehicleFuel: x.codCombustibleBS,
                    vehicleCylinderNumber: x.codNoCilindrosBS,
                    vehicleColor: x.color,
                    vehicleDataLoading: false
                })
            }).finally(() => {
                setLoadingData(false)
                modalLoading.hide();
            })
    }


    return (
        <>
            <InputFile
                id='invoiceFile'
                label='Factura proforma, circulación y/o carta compra y venta'
                files={AutoEmisionCR.invoiceFile}
                onChange={changeFiles}
                maxFiles={4}
                isRequired={AutoEmisionCR.vehicleNew}
            />
            <InputFile
                id='specialEquipmentFile'
                label='Factura de equipos especiales'
                files={AutoEmisionCR.specialEquipmentFile}
                onChange={changeFiles}
                maxFiles={4}
                isRequired={AutoEmisionCR.hasSpecialEquipment}
            />
            <Input
                id='vehiclePlate'
                label='Placa'
                field='vehiclePlate'
                value={AutoEmisionCR.vehiclePlate}
                onChange={ChangeHandler}
                useIconSearch
                onClickIconSeach={() => GetDataByPlate()}
            />
            {loadingData === false &&
                <>
                    <Input
                        id='vehicleEngine'
                        label='Motor'
                        field='vehicleEngine'
                        value={AutoEmisionCR.vehicleEngine}
                        onChange={ChangeHandler}
                    />

                    <Input
                        id='vehicleChasis'
                        label='Chasis'
                        field='vehicleChasis'
                        value={AutoEmisionCR.vehicleChasis}
                        onChange={ChangeHandler}
                    />
                    <Input
                        id='vehicleColor'
                        label='Color'
                        field='vehicleColor'
                        value={AutoEmisionCR.vehicleColor}
                        onChange={ChangeHandler}
                    />
                    <DropDown
                        field='vehicleCylinderNumber'
                        label='No. de cilindros'
                        valueSelect={AutoEmisionCR.vehicleCylinderNumber}
                        onChangeSelect={onChange}
                        dataProvider={AutoEmisionCR.catvehicleCylinderNumber}
                    />
                    <DropDown
                        field='vehicleFuel'
                        label='Combustible'
                        valueSelect={AutoEmisionCR.vehicleFuel}
                        onChangeSelect={onChange}
                        dataProvider={AutoEmisionCR.catvehicleFuel}
                    />
                    <DropDown
                        field='vehicleClass'
                        label='Clase de vehículo'
                        valueSelect={AutoEmisionCR.vehicleClass}
                        onChangeSelect={onChange}
                        dataProvider={AutoEmisionCR.catVehicleClass}
                    />
                    <DropDown
                        field='vehicleDoorNumber'
                        label='No. de puertas'
                        valueSelect={AutoEmisionCR.vehicleDoorNumber}
                        onChangeSelect={onChange}
                        dataProvider={AutoEmisionCR.catVehicleDoorNumber}
                    />
                    <DropDown
                        field='vehicleTransmission'
                        label='Transmisión'
                        valueSelect={AutoEmisionCR.vehicleTransmission}
                        onChangeSelect={onChange}
                        dataProvider={AutoEmisionCR.catVehicleTransmission}
                    />
                </>
            }
            <ModalMsgCtrl {...modalLoading.modal} closeModal={modalLoading.hide} />
        </>
    )
}

export { Step3 }